import { Images, LogoImages, QuestionGroup, QuestionType, ScenarioStep, Steps, Translatable } from '../state/interfaces'
import { emailAddress, provinces, thanks } from './common-steps'

export const startVisitor: ScenarioStep = {
  id: Steps.START_VISITOR,
  group: QuestionGroup.DEFAULT,
  question: 'start-visitor_question',
  tip: 'start-visitor_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  // next: Steps.DONE,
  metadata: { grandImage: Images.MIGRATING },
  answers: [
    {
      id: 'migrating',
      text: 'migrating-to-canada',
      next: Steps.EMAIL_ADDRESS,
    },
    {
      id: 'travelling',
      text: 'travelling-to-canada',
      next: Steps.VISIT_ESIM,
    },
    {
      id: 'live-in-canada',
      text: 'live-in-canada',
      next: Steps.START_QUESTIONNAIRE,
    },
  ],
}

export const emailAddressVisitor: ScenarioStep = {
  ...emailAddress,
  question: 'email-address-visitor_question',
  tip: 'email-address-visitor_tip',
  next: Steps.PROVINCE,
  metadata: { grandImage: Images.MOVE },
}

export const provincesVisitor: ScenarioStep = {
  ...provinces,
  question: 'provinces-visitor_question',
  tip: 'provinces-visitor_tip',
  next: Steps.DATE_PICKER,
  answers: [
    {
      id: 'I-dont-know',
      text: 'i-dont-know-province' as Translatable,
      metadata: { initials: 'i-dont-know', image: LogoImages.DONT_KNOW },
    },
    {
      id: 'alberta',
      text: 'province_alberta' as Translatable,
      metadata: { initials: 'AB', image: LogoImages.ALBERTA },
    },
    {
      id: 'british-columbia',
      text: 'province_british-columbia',
      metadata: { initials: 'BC', image: LogoImages.BRITISH_COLUMBIA },
    },
    { id: 'manitoba', text: 'province_manitoba', metadata: { initials: 'MB', image: LogoImages.MANITOBA } },
    {
      id: 'new-brunswick',
      text: 'province_new-brunswick',
      metadata: { initials: 'NB', image: LogoImages.NEW_BRUNSWICK },
    },
    {
      id: 'newfoundland-labrador',
      text: 'province_newfoundland-labrador',
      metadata: { initials: 'NL', image: LogoImages.NEWFOUNDLAND_AND_LABRADOR },
    },
    {
      id: 'northwest-territories',
      text: 'province_northwest-territories',
      metadata: { initials: 'NT', image: LogoImages.NORTHWEST_TERRITORIES },
    },
    {
      id: 'nova-scotia',
      text: 'province_nova-scotia',
      metadata: { initials: 'NS', image: LogoImages.NOVA_SCOTIA },
    },
    { id: 'nunavut', text: 'province_nunavut', metadata: { initials: 'NU', image: LogoImages.NUNAVUT } },
    { id: 'ontario', text: 'province_ontario', metadata: { initials: 'ON', image: LogoImages.ONTARIO } },
    {
      id: 'prince-edward',
      text: 'province_prince-edward',
      metadata: { initials: 'PE', image: LogoImages.PRINCE_EDWARD_ISLAND },
    },
    { id: 'quebec', text: 'province_quebec', metadata: { initials: 'QC', image: LogoImages.QUEBEC } },
    {
      id: 'saskatchewan',
      text: 'province_saskatchewan',
      metadata: { initials: 'SK', image: LogoImages.SASKATCHEWAN },
    },
    { id: 'yukon', text: 'province_yukon', metadata: { initials: 'YT', image: LogoImages.YUKON } },
  ],
}

export const datePicker: ScenarioStep = {
  id: Steps.DATE_PICKER,
  group: QuestionGroup.DEFAULT,
  question: 'date-picker_question',
  tip: 'date-picker_tip',
  type: QuestionType.INPUT_DATE_PICKER,
  answerPlaceholder: 'date-picker_answerPlaceholder',
  next: Steps.COUNTRY,
  answers: [],
  metadata: { grandImage: Images.TRAVEL },
}

export const country: ScenarioStep = {
  id: Steps.COUNTRY,
  group: QuestionGroup.DEFAULT,
  question: 'country_question',
  tip: 'country_tip',
  type: QuestionType.INPUT_AUTOCOMPLETE,
  answerPlaceholder: 'country_answerPlaceholder',
  next: Steps.CONFIRM_VISITOR,
  answers: [],
  metadata: { grandImage: Images.TRAVEL },
}

export const thanksVisitor: ScenarioStep = {
  ...thanks,
  question: 'thanks-visitor_question',
  tip: 'thanks-visitor_tip',
  answers: [],
}

export const confirmVisitor: ScenarioStep = {
  id: Steps.CONFIRM_VISITOR,
  group: QuestionGroup.DEFAULT,
  type: QuestionType.CHECKBOX_CONFIRM_VISITOR,
  // answerPlaceholder: 'confirm-visitor_answerPlaceholder',
  answers: [{ id: 'confirm-visitor', text: 'common_confirm' }],
  next: Steps.THANKS,
}
